import React from "react";
import pledgeIcon from "../../../assets/pledges.png";
import { useTranslation } from "react-i18next";
import FeedBack from "../../../components/feedback";
function ExportViewPledges() {
  const { t } = useTranslation();
  return (
    <article>
      <h1 className="text-xl md:text-2xl font-bold dark:text-secondaryGreen">
        {t("helpCenter.sidebar.How do I view all group pledges?")}
      </h1>
      <div className="w-full h-[1px] bg-[#eff2f5] dark:bg-[#303032] mt-4 "></div>
      <section className="mt-8">
        <p className="mb-2">
          <span className="font-semibold">Step 1: </span>
          {t("helpCenter.Crowdfunding.viewPledge.step1")}
        </p>
        <p>
          <span className="font-semibold">Step 2: </span>
          {t("helpCenter.Crowdfunding.viewPledge.step2.part1")}
          <img src={pledgeIcon} alt="icon" className="inline-flex w-32" />{" "}
          {t("helpCenter.Crowdfunding.viewPledge.step2.part2")}
          <br />
          <p className="m-2">
            <span className="font-semibold">Note: </span>
            {t("helpCenter.Crowdfunding.viewPledge.step2.note1.part1")}
            {t("helpCenter.Crowdfunding.viewPledge.step2.note1.part2")}
          </p>
        </p>
        <p>
          <span className="font-semibold">Step 3: </span>
          {t("helpCenter.Crowdfunding.viewPledge.step3")}
        </p>
        <p>
          <span className="font-semibold">Step 4: </span>
          {t("helpCenter.Crowdfunding.viewPledge.step4")}
        </p>
        <p>
          <span className="font-semibold">Note: </span>
          {t("helpCenter.Crowdfunding.viewPledge.note")}
        </p>
      </section>
      <FeedBack />
    </article>
  );
}

export default ExportViewPledges;
